export const formatErrorMessage = (message: unknown): string => {
  if (typeof message === 'string') return message
  if (message instanceof Error) return message.message
  return JSON.stringify(message)
}
